import { render, staticRenderFns } from "./ProspectStatus.vue?vue&type=template&id=96b323a4&scoped=true&"
import script from "./ProspectStatus.vue?vue&type=script&lang=js&"
export * from "./ProspectStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProspectStatus.vue?vue&type=style&index=0&id=96b323a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b323a4",
  null
  
)

export default component.exports